// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const CypressRunning = window.Cypress || window.parent.Cypress
